import dish1 from './images/Dish-1.png';
import dish2 from './images/Dish-2.png';
import dish3 from './images/Dish-3.png';
import dish4 from './images/Dish-4.png';

const productData = [
    {
        id: 1,
        image: dish1,
        tittle: "Lumpia",
        description: "The filling of lumpia can vary depending on personal preference  variations dishes with lumpia."
    },
    {
        id: 2,
        image: dish2,
        tittle: "Fish and Veggie",
        description: "Fish have streamlined bodies with fins and scales,Eating a variety of vegetables dishes with Fish."
    },
    {
        id: 3,
        image: dish3,
        tittle: "Tofu Chili",
        description: "It is a popular vegetarian or vegan alternative to traditional chili made with meat."
    },
    {
        id: 4,
        image: dish4,
        tittle: "Egg & Cocumber",
        description: "Egg and cucumber dish is a simple yet refreshing and nutritious dish that combines the flavors."
    }
]
export default productData;